//@flow
import { commitMutation, graphql } from 'react-relay';
import type { PayloadError } from 'react-relay';

const mutation = graphql`
    mutation profileAddressMutation($input: FirmDesignProfileAddressMutationInput!) {
        firmDesignProfileAddressMutation(input: $input) {
            tradeFirm {
                publicProfile {
                    address {
                        city
                        state
                        country
                        zipCode
                    }
                }
            }
        }
    }
`;

type ProfileAddressMutationArgs = {
    firmId: string,
    city?: ?string,
    state?: ?string,
    country: string,
    zipCode: string,
};

export const profileAddressMutation = (
    environment: Object,
    args: ProfileAddressMutationArgs
): Promise<void> => {
    const { firmId, city, state, country, zipCode } = args;
    const input = {
        serviceId: firmId,
        city,
        state,
        country,
        zipCode,
    };

    return new Promise((resolve, reject) => {
        const onCompleted = (response, errors: ?Array<PayloadError>) => {
            if (errors && errors.length) {
                reject(errors);
            }
            resolve(response);
        };

        const onError = (error: Error) => {
            reject([error]);
        };

        commitMutation(environment, {
            mutation,
            variables: { input },
            onCompleted,
            onError,
        });
    });
};
